import { PostAuthor } from '@bridebook/toolbox/src/schemas/article/types';
import { TColor } from '@bridebook/ui';
import { IconInstagram, IconLinkedin, IconTiktok, IconWeb } from '@bridebook/ui/src/icons';

interface INetworks {
  name: string;
  icon: Function;
  iconWidth: number;
  color: TColor;
  url?: string;
}

export const AUTHOR_ARTICLES_PER_PAGE = 12;

export const networks: INetworks[] = [
  {
    name: 'linkedin',
    icon: IconLinkedin,
    iconWidth: 12,
    color: 'black',
  },
  {
    name: 'instagram',
    icon: IconInstagram,
    iconWidth: 12,
    color: 'black',
  },
  {
    name: 'tiktok',
    icon: IconTiktok,
    iconWidth: 12,
    color: 'black',
  },
  {
    name: 'website',
    icon: IconWeb,
    iconWidth: 12,
    color: 'black',
  },
];

export const getAuthorNetworks = (authorDetails?: PostAuthor): INetworks[] => {
  const urls: Record<string, string | undefined> = {
    linkedin: authorDetails?.linkedin,
    instagram: authorDetails?.instagram,
    tiktok: authorDetails?.bb_tiktok,
    website: authorDetails?.bb_website,
  };

  return networks.map((n) => ({ ...n, url: urls[n.name] })).filter((n) => Boolean(n.url));
};
